class SafeLoadScripts extends HTMLElement {
  constructor() {
    super();
  }


  connectedCallback() {
    const scripts = this.querySelectorAll('safe-load-scripts > script');

    scripts.forEach((script) => {
      const key = script.dataset.flowLoadKey;

      const scriptLoaded = window.wetheme.webcomponentRegistry.checkScriptLoaded(key);
      if(!scriptLoaded) {
        const postLoadedScript = document.createElement('script');
        const {src, defer, async, type} = script;
        postLoadedScript.src = src;
        postLoadedScript.defer = defer;
        postLoadedScript.async = async;
        postLoadedScript.type = type;


        this.parentElement.appendChild(postLoadedScript);

      }
    })

  }
}
  
customElements.define('safe-load-scripts', SafeLoadScripts);

/* PP_META_LEAD_TRACKING_ASSET_BRIDGE_V1 */
(function () {
  var leadPaths = [
    "/pages/free-circuits-escape-room",
    "/pages/free-electrostatics-warmups"
  ];
  if (leadPaths.indexOf(window.location.pathname) === -1) return;

  var pixelId = "1461056888962684";
  var firedKey = "pp_meta_lead_fired_" + window.location.pathname;

  function fireLead(reason) {
    try {
      if (sessionStorage.getItem(firedKey)) return;
      sessionStorage.setItem(firedKey, "1");
    } catch (e) {}

    var params = {
      id: pixelId,
      ev: "Lead",
      dl: window.location.href,
      rl: document.referrer || "",
      if: "false",
      ts: Math.floor(Date.now() / 1000),
      "cd[content_name]": "Phantastic Physics Lead Magnet",
      "cd[content_category]": "lead_magnet",
      "cd[reason]": reason || "form_interaction"
    };
    var query = Object.keys(params).map(function (key) {
      return encodeURIComponent(key) + "=" + encodeURIComponent(params[key]);
    }).join("&");
    var img = new Image();
    img.src = "https://www.facebook.com/tr/?" + query;

    try {
      if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) {
        Shopify.analytics.publish("pp_lead_magnet_submit", {
          path: window.location.pathname,
          reason: reason || "form_interaction"
        });
      }
    } catch (e) {}
  }

  document.addEventListener("submit", function (event) {
    var form = event.target;
    if (!form || !form.querySelector) return;
    if (form.querySelector('input[type="email"], input[name*="email" i]')) {
      fireLead("email_form_submit");
    }
  }, true);

  document.addEventListener("click", function (event) {
    var target = event.target;
    if (!target || !target.closest) return;
    var button = target.closest('button, input[type="submit"], a');
    if (!button) return;
    var text = ((button.innerText || button.value || button.getAttribute("aria-label") || "") + "").toLowerCase();
    if (/(download|get|send|free|access|claim)/.test(text)) {
      var nearby = button.closest("form, section, div");
      if (!nearby || (nearby.querySelector && nearby.querySelector('input[type="email"], input[name*="email" i]'))) {
        fireLead("lead_cta_click");
      }
    }
  }, true);
})();
/* /PP_META_LEAD_TRACKING_ASSET_BRIDGE_V1 */


/* PP_ATTRIBUTION_SAFELOAD_BRIDGE_V1 */
(function () {
  var allowedPaths = {
    "/pages/free-circuits-escape-room": true,
    "/pages/welcome-offer": true
  };
  if (!allowedPaths[window.location.pathname]) return;

  var ledger = "https://146.190.46.95/pp-attribution/collect.gif";
  var storageKey = "pp_first_touch_attribution_v1";
  var eventKey = "pp_attr_event_" + window.location.pathname;
  var intentKey = "pp_attr_intent_" + window.location.pathname;
  var trackedKeys = [
    "utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term",
    "fbclid", "gclid", "ttclid", "msclkid"
  ];

  function anonId() {
    try {
      var key = "pp_attribution_anon_id_v1";
      var existing = localStorage.getItem(key);
      if (existing) return existing;
      var value = "pp_" + Date.now() + "_" + Math.random().toString(36).slice(2);
      localStorage.setItem(key, value);
      return value;
    } catch (e) {
      return "pp_" + Date.now() + "_" + Math.random().toString(36).slice(2);
    }
  }

  function paramsFromSearch() {
    var out = {};
    var params = new URLSearchParams(window.location.search || "");
    trackedKeys.forEach(function (key) {
      var value = params.get(key);
      if (value) out[key] = value;
    });
    return out;
  }

  function sourceFromReferrer(referrer) {
    var host = "";
    try { host = new URL(referrer).hostname.toLowerCase(); } catch (e) {}
    if (!host) return "";
    if (host.indexOf("facebook.") !== -1 || host.indexOf("fb.") !== -1 || host.indexOf("l.facebook") !== -1) return "facebook";
    if (host.indexOf("instagram.") !== -1) return "instagram";
    if (host.indexOf("tiktok.") !== -1) return "tiktok";
    if (host.indexOf("youtube.") !== -1 || host.indexOf("youtu.be") !== -1) return "youtube";
    if (host.indexOf("pinterest.") !== -1) return "pinterest";
    if (host.indexOf("teacherspayteachers.") !== -1) return "teacherspayteachers";
    if (host.indexOf("google.") !== -1) return "google";
    return host.replace(/^www\./, "");
  }

  function readStored() {
    try { return JSON.parse(localStorage.getItem(storageKey) || "{}") || {}; }
    catch (e) { return {}; }
  }

  function writeStored(data) {
    try { localStorage.setItem(storageKey, JSON.stringify(data)); } catch (e) {}
  }

  function attribution() {
    var current = paramsFromSearch();
    var stored = readStored();
    var referrerSource = sourceFromReferrer(document.referrer || "");
    var hasCurrent = Object.keys(current).length > 0;

    if (hasCurrent && !stored.first_seen_at) {
      current.first_seen_at = new Date().toISOString();
      current.landing_page = window.location.href;
      current.referring_site = document.referrer || "";
      writeStored(current);
      stored = current;
    } else if (!stored.first_seen_at && referrerSource) {
      stored = {
        utm_source: referrerSource,
        utm_medium: "referral",
        first_seen_at: new Date().toISOString(),
        landing_page: window.location.href,
        referring_site: document.referrer || ""
      };
      writeStored(stored);
    }

    var merged = {};
    trackedKeys.forEach(function (key) {
      if (current[key]) merged[key] = current[key];
      else if (stored[key]) merged[key] = stored[key];
    });
    if (!merged.utm_source && referrerSource) merged.utm_source = referrerSource;
    if (!merged.utm_medium && merged.utm_source) merged.utm_medium = referrerSource ? "referral" : "unknown";
    if (stored.referring_site || document.referrer) merged.referring_site = stored.referring_site || document.referrer;
    merged.anon_id = anonId();
    merged.page_url = window.location.href;
    merged.referrer = document.referrer || "";
    return merged;
  }

  function sendEvent(eventType) {
    var attrs = attribution();
    attrs.event_type = eventType || "lead_page_view";
    var qs = new URLSearchParams();
    Object.keys(attrs).forEach(function (key) {
      if (attrs[key]) qs.set(key, attrs[key]);
    });
    var img = new Image();
    img.referrerPolicy = "no-referrer-when-downgrade";
    img.src = ledger + "?" + qs.toString();
  }

  function decorateBeehiivFrame(frame) {
    if (!frame || !frame.src || frame.src.indexOf("subscribe-forms.beehiiv.com") === -1) return;
    try {
      var url = new URL(frame.src);
      var attrs = attribution();
      Object.keys(attrs).forEach(function (key) {
        if (attrs[key] && key !== "event_type" && !url.searchParams.get(key)) {
          url.searchParams.set(key, attrs[key]);
        }
      });
      var next = url.toString();
      if (frame.src !== next) frame.src = next;
    } catch (e) {}
  }

  function decorateAll() {
    document.querySelectorAll('iframe[src*="subscribe-forms.beehiiv.com"]').forEach(decorateBeehiivFrame);
  }

  function recordIntent() {
    try {
      if (sessionStorage.getItem(intentKey)) return;
      sessionStorage.setItem(intentKey, "1");
    } catch (e) {}
    sendEvent("beehiiv_form_intent");
  }

  function boot() {
    decorateAll();
    try {
      if (!sessionStorage.getItem(eventKey)) {
        sessionStorage.setItem(eventKey, "1");
        sendEvent("lead_page_view");
      }
    } catch (e) {
      sendEvent("lead_page_view");
    }
    document.querySelectorAll('iframe[src*="subscribe-forms.beehiiv.com"]').forEach(function (frame) {
      frame.addEventListener("mouseenter", recordIntent, { once: true });
      frame.addEventListener("touchstart", recordIntent, { once: true });
      frame.addEventListener("click", recordIntent, { once: true });
    });
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
  setTimeout(boot, 500);
  setTimeout(boot, 1500);
  setTimeout(boot, 3000);
  try {
    new MutationObserver(decorateAll).observe(document.documentElement, { childList: true, subtree: true });
  } catch (e) {}
})();
/* /PP_ATTRIBUTION_SAFELOAD_BRIDGE_V1 */

